import { render, staticRenderFns } from "./CollectionDetailDialog.vue?vue&type=template&id=63f0494e&scoped=true"
import script from "./CollectionDetailDialog.vue?vue&type=script&lang=js"
export * from "./CollectionDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./CollectionDetailDialog.vue?vue&type=style&index=0&id=63f0494e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f0494e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f0494e')) {
      api.createRecord('63f0494e', component.options)
    } else {
      api.reload('63f0494e', component.options)
    }
    module.hot.accept("./CollectionDetailDialog.vue?vue&type=template&id=63f0494e&scoped=true", function () {
      api.rerender('63f0494e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantReconciliation/list/components/CollectionDetailDialog.vue"
export default component.exports